import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;
    var isVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove(
              "show-sticky-cart-active"
            );
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();

/* Tipo workshop widget fixes: (1) rename the service label, (2) keep the notes field readable */
(function () {
  try {
    var st = document.createElement("style");
    st.textContent =
      ".tpb-booking-form textarea, .tpb-form-control.booking-note, textarea.booking-note { background-color: #fff !important; color: #1d1d1f !important; -webkit-text-fill-color: #1d1d1f !important; caret-color: #1d1d1f !important; opacity: 1 !important; }";
    document.head.appendChild(st);

    var FROM = /make it low (and|&) slow/i;
    var TO = "Bedrijfs workshop op maat";
    var busy = false;
    var run = function () {
      if (busy || !document.body) return;
      busy = true;
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) continue;
        if (FROM.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(FROM, TO);
      }
      /* inline !important beats any stylesheet rule the booking app injects */
      var areas = document.querySelectorAll(".tpb-booking-form textarea, .tpb-form-control.booking-note, textarea.booking-note");
      for (var i = 0; i < areas.length; i++) {
        var s = areas[i].style;
        s.setProperty("color", "#1d1d1f", "important");
        s.setProperty("-webkit-text-fill-color", "#1d1d1f", "important");
        s.setProperty("background-color", "#ffffff", "important");
        s.setProperty("caret-color", "#1d1d1f", "important");
      }
      busy = false;
    };
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    });
    var start = function () {
      run();
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else {
      start();
    }
  } catch (e) {}
})();

/* Workshops: skip the cart page and go straight to the checkout after a Tipo booking is added to the cart */
(function () {
  try {
    var goCheckout = function () {
      /* Tipo sends the customer to /cart right after the add; later calls override that navigation */
      [0, 40, 120, 300, 700].forEach(function (ms) {
        setTimeout(function () {
          if (location.pathname.indexOf("/checkout") !== 0) location.replace("/checkout");
        }, ms);
      });
    };
    var isBookingPage = function () {
      return !!document.querySelector(".tpb-booking-form, .tpb-product-page");
    };
    var isCartAdd = function (u) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(u || ""));
    };

    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (String(method).toUpperCase() === "POST" && isCartAdd(url) && isBookingPage()) {
          this.addEventListener("load", function () {
            if (this.status >= 200 && this.status < 300) goCheckout();
          });
        }
      } catch (e) {}
      return open.apply(this, arguments);
    };

    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var u = typeof input === "string" ? input : input && input.url;
        var m = (init && init.method) || (input && input.method) || "GET";
        if (String(m).toUpperCase() === "POST" && isCartAdd(u) && isBookingPage()) {
          p.then(function (r) {
            if (r && r.ok) goCheckout();
          });
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}
})();
